import React from 'react';
import CommunityImg from '../../imgs/community.jpg';

const Community: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext mb-12 text-center">
          Community Breathwork
        </h1>
        <div className="flex items-center justify-center bg-lighttan">
            <img
            src={CommunityImg}
            alt="Breathwork Class 1"
            className="mx-auto w-1/3 h-auto rounded-lg shadow-lg object-cover object-center"
            />
        </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
          Come together as a community to embark on a 45 minute guided and meditative group breathing 
          session.  Each person can have a unique experience and this is a safe space.
        </p>
        <p className="text-xl text-darkgreentext leading-relaxed mt-4">
          If you prefer a quieter and/or more private experience, please set up a private appointment.
        </p>
      </div>
      <div className="flex justify-center pb-8">
        <a
          href="https://calendly.com/seanmotiv8living/group-breathwork-class?back=1"
          className="px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition"
        >
          Sign Up Now
        </a>
      </div>
    </div>
  );
};

export default Community;
